// extracted by mini-css-extract-plugin
export default {"demoDisplay":"CJ4D6R","disabled":"xiaJjb","newDemoDisplayUi":"_TGeKT"};